/**
 * RESPONSIBILITY: the Children's Ministry page's age-groups band.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { AgeGroup } from './rows/age-group';

@Section({ name: SectionName.ChildrenAges, label: 'Children — age groups' })
export class ChildrenAgesSection {
  @Text({ label: 'Title', maxLength: 120, default: 'Age groups' })
  agesHeading!: string;

  @List({ label: 'Age groups', of: () => AgeGroup, maxItems: 12 })
  ages!: AgeGroup[];
}
